import { jsx as _jsx } from "react/jsx-runtime";
const CardTitle = ({ title, className = "" }) => {
    return (_jsx("h2", { className: `
        text-[2.8rem] 
        font-medium
        leading-normal 
        ${className}
      `, children: title }));
};
export default CardTitle;
//# sourceMappingURL=CardTitle.js.map